var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"image"},[_c('van-image',{attrs:{"width":"100%","height":"240px","fit":"cover","src":_vm.news.top_image}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }